import React from 'react';

const REFERENCE = new Array(100).fill(null);

let button = null;
let container = null;
let counting = false;
let key = 0;
let videoContainerNode = null;
function setup() {
  button = document.getElementById('button');
  container = document.getElementById('container');
  button.addEventListener('click', click);
}

function click() {
  if (!counting) {
    counting = true;
    chainRender();
  } else {
    counting = false;
  }
}

function chainRender() {
  if (videoContainerNode != null) {
    container.removeChild(videoContainerNode);
  }
  videoContainerNode = document.createElement('div');
  videoContainerNode.id = `container-${key}`;
  REFERENCE.forEach(() => {
    const node = document.createElement('video');
    node.src = '';
    videoContainerNode.appendChild(node);
  });

  container.appendChild(videoContainerNode);

  key += 1;
  if (counting) {
    button.innerHTML = `Rendering new elements using DOM ${key}`;
    setTimeout(chainRender, 100);
  } else {
    button.innerHTML = 'Native DOM Rendering';
  }
}

class App extends React.Component {
  state = {
    counting: false,
    key: 0,
  };

  componentDidMount() {
    setup();
  }

  componentDidUpdate() {
    if (this.state.counting) {
      setTimeout(() => this.setState(({key}) => ({key: key + 1})), 100);
    }
  }

  render() {
    const {counting, key} = this.state;
    return (
      <div>
        <div style={{marginBottom: 10}}>
          <a href="https://gist.github.com/amadeus/aa87fb4aa68ab170520abed881c75798">Source</a>
        </div>
        <button onClick={() => this.setState(({counting}) => ({counting: !counting}))}>
          {counting ? `Rendering new elements using React ${this.state.key}` : 'React DOM Rendering'}
        </button>
        <button id="button">Native Dom Rendering</button>
        <div key={key}>
          {REFERENCE.map((_, i) => (
            <video key={i} />
          ))}
        </div>
        <div id="container" />
      </div>
    );
  }
}

export default App;
